<template lang="pug">
div
  screen-title(title="discounts.title")
    action-button(@click="addEditDiscount" title="discounts.actions.add" icon="plus" permission="DISCOUNTS_MANAGE")
  .box
    
    b-table(
      :data="discounts" 
      draggable
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
      :loading="loading" 
      hoverable 
      class="is-vertically-aligned" 
      @click="addEditDiscount" 
      custom-row-key="_id")
      b-table-column(field="name" width="50%" :label="$t('discounts.name_heading')" v-slot="props") 
        .is-flex.is-align-items-center
          div 
            span.icon.is-draggable.has-text-grey-light.is-small.mr-2
              i.mdi.mdi-drag.mdi-16px
          
          div
            p.title.is-6
              span {{props.row.name}}
      b-table-column(field="value" :label="$t('discounts.value_heading')" v-slot="props") 
        span {{props.row.value}}% 
      b-table-column(field="active" :label="$t('discounts.value_heading')" v-slot="props") 
        span.tag.is-success(v-if="props.row.active") {{$t('misc.active')}}
        span.tag(v-if="!props.row.active") {{$t('misc.inactive')}}
      b-table-column(field="locations" :label="$t('discounts.locations_heading')" v-slot="props" :visible="hasMultipleLocations") 
        template(v-if="props.row.locations && props.row.locations.length")
          
          p(v-for="location in props.row.locations" :key="location")
            location-view(:value="location")
        template(v-else)
          span.has-text-grey-light(v-t="'discounts.all_locations'")
      template(slot="empty")
        empty-content(icon="close-circle-outline" title="discounts.no_discounts")
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import DiscountCreateEditModal from './DiscountCreateEditModal'
export default {
  name: 'Discounts',
  computed: {
    ...mapGetters('discounts', ['discounts', 'discountsByLocation']),
    ...mapState('discounts', ['loading', 'discountsMap']),
    ...mapGetters('location', ['hasMultipleLocations']),
    availableDiscounts() {
      if (this.$rfLocationScope() || this.$rfProfileScope()) {
        return this.discountsByLocation(this.user.location)
      }
      return this.discounts
    }
  },
  methods: {
    ...mapActions('discounts', ['updateDiscountsOrder']),
    addEditDiscount(row) {
      this.$buefy.modal.open({
        parent: this,
        component: DiscountCreateEditModal,
        hasModalCard: true,
        fullScreen: true,
        props: {discountId: row && row._id},
        canCancel: ['escape']
      })
    },
    dragstart(payload) {
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      if (this.draggingRowIndex === payload.index) return
      let order = this.availableDiscounts.map(s => s._id)
      let draggingId = order[this.draggingRowIndex]

      order.splice(this.draggingRowIndex, 1)
      order.splice(payload.index, 0, draggingId)

      this.updateDiscountsOrder(order)
    }
  }
}
</script>
